import "./OrangeCircle.scss";

function OrangeCircle({ ariaLabel }: { ariaLabel?: string }) {
  return <div aria-label={ariaLabel} className="OrangeCircle" role="img" />;
}

export { OrangeCircle };
